import { ChallengeType, SecurityMessage } from '@treasury/domain/channel/mappings/security';
import type {
    IdentityDialogContext,
    IdentityDialogStrategy,
} from '../identity-verification-dialog.types';
import { Oob } from './oob';
import { OobOtp } from './oob-otp';
import { SecureToken } from './secure-token';

export * from './null-strategy';

export function createDialogStrategy(
    context: IdentityDialogContext,
    challengeMethodType: SecurityMessage['challengeMethodTypeId']
): IdentityDialogStrategy {
    switch (challengeMethodType) {
        case ChallengeType.OutOfBand:
            return new Oob(context);
        case ChallengeType.OutOfBandOTP:
            return new OobOtp(context);
        case ChallengeType.SecureToken:
            return new SecureToken(context);
        case 0:
            throw new Error(
                'Cannot create identity dialog strategy. Challenge code zero provided. Did you forget to normalize in client code?'
            );
        default:
            throw new Error(
                `Cannot create identity dialog strategy. Invalid challenge code ${challengeMethodType} provided.`
            );
    }
}
